'use strict';

var customFieldModule = angular.module('t2g.customFields', [
    'gettext',
    'ui.router',
    require('t2g.common.services.notificationService').name
]);

module.exports = customFieldModule;

customFieldModule.config(function ($stateProvider) {
    $stateProvider
        .state('private.main.customFields', {
            url: '/customFields',
            title: 'Custom Fields',
            templateUrl: 'https://cdn.termin2go.com/app/app/modules/customFields/CustomFieldsView.html?v=3.92.3',
            controller: 'CustomFieldsCtrl as CustomFieldsCtrl',
            resolve: {
                officeResolve: function (OfficeDA) {
                    return OfficeDA.get();
                }
            }
        })
        .state('private.main.customFieldAppointment', {
            url: '/customFields/appointment/:name',
            title: 'Appointment Field',
            templateUrl: 'https://cdn.termin2go.com/app/app/modules/customFields/CustomFieldsDetailView.html?v=3.92.3',
            controller: 'CustomFieldsDetailCtrl as CustomFieldsDetailCtrl',
            resolve: {
                office: function (OfficeDA) {
                    return OfficeDA.get();
                },
                type: () => 'appointment'
            }
        })
        .state('private.main.customFieldCustomer', {
            url: '/customFields/customer/:name',
            title: 'Customer Field',
            templateUrl: 'https://cdn.termin2go.com/app/app/modules/customFields/CustomFieldsDetailView.html?v=3.92.3',
            controller: 'CustomFieldsDetailCtrl as CustomFieldsDetailCtrl',
            resolve: {
                office: function (OfficeDA) {
                    return OfficeDA.get();
                },
                type: () => 'customer'
            }
        });
});

customFieldModule.controller('CustomFieldsCtrl', require('./CustomFieldsCtrl'));
customFieldModule.controller('CustomFieldsDetailCtrl', require('./CustomFieldsDetailCtrl'));
